const $ = window.jQuery

/**
 * Enables 'MWB WooCommerce Notices' plugin specific scripting
 */
const WooCommerceWishlist = {

    lastRequestedAt: false, // keep track of last request's time (to ignore delayed responses)

    /**
     * Initialise functionality
     */
    init() {

        this.bindToggles()

        // TODO - handle new elements injected (like post forms)

    },

    /**
     * Bind click events on toggle buttons
     */
    bindToggles() {

        const vm = this

        $('.toggle-wishlist-link[data-wishlist-id]').on('click', function (e) {
            e.preventDefault()

            const $link = $(this)
            const wishlistId = $link.data('wishlist-id')

            vm.toggleItem(wishlistId)
        })

    },

    /**
     * Toggle item via AJAX
     * 
     * @param {int} itemId 
     */
    toggleItem(itemId) {

        const vm = this

        // Indicate "thinking"
        vm.getItemToggles(itemId).addClass('thinking')

        vm.lastRequestedAt = (new Date()).getTime()

        let data = {
            'action':       'toggle_wishlist',
            'requested-at': vm.lastRequestedAt,
            'item-id':      itemId,
        }

        $.ajax({
            type:       'POST',
            url:        scriptVars.ajaxUrl,
            dataType:   'json',
            data,
            success: function (res) {
                if (res.success && res.data.requested_at == vm.lastRequestedAt) {
                    if (res.data.requested_at == vm.lastRequestedAt) { // only use most recent request's response

                        const { message, added } = res.data

                        if (typeof added != 'undefined') {
                            vm.addNotice(message || (added ? 'Item added' : 'Item removed'), 'success')
                            vm.getItemToggles(itemId).toggleClass('active', added)
                        } else {
                            // Assume error if no "added" (probably the "you must be signed in" message)
                            vm.addNotice(message, 'error')
                        }

                    }
                } else {
                    vm.addNotice(res.data.message || 'Something went wrong, please try again later', 'error')
                }
            },
            error: function (err) {
                console.error('err', err)
                vm.addNotice(err.data.message || 'Something went wrong, please try again later', 'error')
            },
            complete: function () {
                vm.getItemToggles(itemId).removeClass('thinking')
            },
        })

    },

    /**
     * Get list of toggles for the given wishlist item
     * @param {int} itemId 
     * @returns Return list of jQuery elements
     */
    getItemToggles(itemId) {
        return $(`.toggle-wishlist-link[data-wishlist-id="${itemId}"]`)
    },

    /**
     * Trigger "add notice" event
     * @param {string} message Message of notice
     * @param {string} type Type of notice
     */
    addNotice(message, type) {
        $(window).trigger(
            'mwb/plugin/woocommerce_notices/add_notice', {
                message,
                type,
            }
        )
    }

}

export default WooCommerceWishlist;